export default __webpack_public_path__ + "assets/images/4.e968c9.png";